import {MutationTree} from 'vuex';
import {ConfigState} from "@/store/modules/config/index";
import {FeatureFlag} from "@/models/response/BrainpowerApiResponse";

export const mutations: MutationTree<ConfigState> = {

  setFeatureFlags: (state, features:FeatureFlag) => {
    state.featureFlags = features;
},

}
